import { styles } from '~/modules/styles.ts';
import { Box, Typography, Button, Grid } from '@mui/material';
import { useApplicationsContactInformationForm } from '~/modules/remote-banking-contacts/hooks/useHookForms.ts';
import { FormPhoneField } from '~/components/FormComponents/FormPhoneField.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';

export const ContactInformationForm = () => {
  const form = useApplicationsContactInformationForm();

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.pageTitle}>
        Надати інформацію щодо актуальних контактних даних керівника
      </Typography>
      <Grid sx={styles.fieldsWrapper}>
        <FormPhoneField
          allowedCountries={['UA']}
          name="phoneNumber"
          label={'Номер контактного телефону'}
        />
        <FormInput
          fullWidth
          name="email"
          label="Адреса електронної пошти"
          placeholder="Введіть адресу електронної пошти"
        />
      </Grid>
      <Button variant="contained" size="large" type="submit" disabled={form.formState.isSubmitting}>
        Отримати посилання
      </Button>
    </Box>
  );
};
